import React from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import { GEIST_INPUT } from "./UnderlineInput";

// Journal dates are plain calendar days ("2026-10-30") — the ERP contract and the
// Portal store them as ISO strings. Parse/format by parts (never through UTC) so a
// day never shifts, and show them dd/MM/yyyy like the rest of the Payment Request.
const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})/;

export const isoToDate = (iso) => {
  const m = ISO_DAY.exec(iso || "");
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12) : null;
};

const pad = (n) => String(n).padStart(2, "0");
export const dateToIso = (date) =>
  (date ? `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` : "");

/** "2026-10-08" or "2026-10-08T00:00:00" → "08/10/2026"; anything else unchanged. */
export const formatIsoDay = (value) => {
  const m = ISO_DAY.exec(value || "");
  return m ? `${m[3]}/${m[2]}/${m[1]}` : value;
};

const IsoDateInput = ({ value, onChange, disabled, className = "", "aria-label": ariaLabel, "aria-required": ariaRequired }) => (
  <DatePicker
    selected={isoToDate(value)}
    onChange={(date) => onChange(dateToIso(date))}
    dateFormat="dd/MM/yyyy"
    placeholderText="dd/mm/yyyy"
    disabled={disabled}
    // The accessible name lives on the text box itself (DatePicker drops aria-label).
    customInput={<input autoComplete="off" aria-label={ariaLabel} aria-required={ariaRequired} />}
    // Rendered on <body>: the journal table scrolls sideways and would clip it.
    portalId="payment-journal-datepicker"
    className={`${GEIST_INPUT} tw-h-9 tw-text-[13px] ${className}`}
  />
);

IsoDateInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "aria-required": PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default IsoDateInput;
